import { memo } from "react";
import { ColorPicker, Slider, InputNumber, Select, Divider } from "antd";
import styled from "styled-components";
import { LayerStyles, colorToHex, dashOptions } from "../types";

interface PolygonStyleTabProps {
  styles: LayerStyles;
  onUpdate: (field: keyof LayerStyles['polygon'], value: any) => void;
}

const PolygonStyleTab = ({ styles, onUpdate }: PolygonStyleTabProps) => {
  return (
    <StyleForm>
      <FormRow>
        <FormLabel>Màu tô:</FormLabel>
        <ColorPicker
          value={styles.polygon.fillColor}
          onChange={(color) => onUpdate('fillColor', colorToHex(color))}
          showText
        />
      </FormRow>

      <FormRow>
        <FormLabel>Độ mờ tô:</FormLabel>
        <Slider
          min={0}
          max={1}
          step={0.1}
          value={styles.polygon.fillOpacity}
          onChange={(value) => onUpdate('fillOpacity', value)}
          style={{ flex: 1 }}
        />
        <span style={{ width: 60, textAlign: 'center' }}>
          {Math.round(styles.polygon.fillOpacity * 100)}%
        </span>
      </FormRow>

      <Divider />

      <FormRow>
        <FormLabel>Màu viền:</FormLabel>
        <ColorPicker
          value={styles.polygon.strokeColor}
          onChange={(color) => onUpdate('strokeColor', colorToHex(color))}
          showText
        />
      </FormRow>

      <FormRow>
        <FormLabel>Độ dày viền:</FormLabel>
        <Slider
          min={1}
          max={8}
          value={styles.polygon.strokeWidth}
          onChange={(value) => onUpdate('strokeWidth', value)}
          style={{ flex: 1 }}
        />
        <InputNumber
          min={1}
          max={8}
          value={styles.polygon.strokeWidth}
          onChange={(value) => onUpdate('strokeWidth', value || 2)}
          style={{ width: 60 }}
        />
      </FormRow>

      <FormRow>
        <FormLabel>Độ mờ viền:</FormLabel>
        <Slider
          min={0}
          max={1}
          step={0.1}
          value={styles.polygon.strokeOpacity}
          onChange={(value) => onUpdate('strokeOpacity', value)}
          style={{ flex: 1 }}
        />
        <span style={{ width: 60, textAlign: 'center' }}>
          {Math.round(styles.polygon.strokeOpacity * 100)}%
        </span>
      </FormRow>

      <FormRow>
        <FormLabel>Kiểu viền:</FormLabel>
        <Select
          value={styles.polygon.dashPattern}
          onChange={(value) => onUpdate('dashPattern', value)}
          options={dashOptions}
          style={{ flex: 1 }}
        />
      </FormRow>
    </StyleForm>
  );
};

export default memo(PolygonStyleTab);

const StyleForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 0;
`;

const FormRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const FormLabel = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  min-width: 120px;
`;
